import { render, staticRenderFns } from "./CsrContent3.vue?vue&type=template&id=b620c46e&scoped=true"
import script from "./CsrContent3.vue?vue&type=script&lang=js"
export * from "./CsrContent3.vue?vue&type=script&lang=js"
import style0 from "./CsrContent3.vue?vue&type=style&index=0&id=b620c46e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b620c46e",
  null
  
)

export default component.exports